import { render, staticRenderFns } from "./searchInsured.vue?vue&type=template&id=476d1f3a&scoped=true&"
import script from "./searchInsured.vue?vue&type=script&lang=js&"
export * from "./searchInsured.vue?vue&type=script&lang=js&"
import style0 from "./searchInsured.vue?vue&type=style&index=0&id=476d1f3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476d1f3a",
  null
  
)

export default component.exports